/**
 * v0.4
 * @author Gabe Rose (gabe@equisolve.com)
 * This plugin is used to generate and configure charts dynamically via an HTML data
 * attribute interface.
 **/
 function ChartBuilder (el) {
    var apiUrl = '/api/v1/chart-data';
    var self = this;
    this.el = el;
    this.cid = el.getAttribute('data-cid');
    this.pid = el.getAttribute('data-pid');
    this.name = el.getAttribute('data-chart-name');
    this.type = el.getAttribute('data-chart-type');
    this.title = el.getAttribute('data-chart-title');
    this.fieldName = el.getAttribute('data-field-name');
    this.unitType = el.getAttribute('data-unit-type');
    this.donutSolid = el.getAttribute('data-donut-solid') == 'true' ? true : false;
    this.isFinancialChart = el.getAttribute('data-financial-chart');
    this.isYoYChart = el.getAttribute('data-yoy-chart');
    this.isSeriesChart = false;
    this.hideToolTip = el.getAttribute('data-hide-tooltip');
    this.legend = el.getAttribute('data-legend') === 'true' ? true : false;
    this.extraOptionsId = el.getAttribute('data-extra-options-id');
    this.unitScale = el.getAttribute('data-unit-scale');
    this.width = el.getAttribute('data-width');
    this.data = {};
    this.chart = {};
    
    function nextValue(num) { 
      return p[(jq.inArray(num, p) + 1) % p.length]; 
    }
    
    function getOptions() {
        var opts = {};
        if (self.type == 'pie') {
            opts = {
                height: 220,
                donut: true,
                donutWidth: 40,
                donutSolid: self.donutSolid,
                showLabel: false,
                plugins: [
                    // Chartist.plugins.ctPieLabels({
                    //     labelInterpolationFnc: function (value, totalValueSum) {
                    //         return Math.round((value / totalValueSum) * 100) + '%';
                    //     }
                    // }),
                    Chartist.plugins.tooltip({
                        appendToBody: true,
                        transformTooltipTextFnc: function (value) {
                            var label = '';
                            var labelIndex = self.data.labelValues.indexOf(value);
                            label = self.data.labels[labelIndex] || '';
                            return label || value + '%';
                        }
                    }),
                ]
            };
            if (self.legend) {
                opts.plugins.push(Chartist.plugins.legend({
                        clickable: false,
                        position: jq(self.el).closest('.chart-wrapper').find('.ct-legend-wrapper')[0] ? jq(self.el).closest('.chart-wrapper').find('.ct-legend-wrapper')[0] : 'bottom'
                    }));
            }
        }else {
            opts = {
                height: 350,
                width: self.width,
                distributeSeries: !self.isSeriesChart,
                axisX: {
                    showGrid: false,
                },
                axisY: {
                    showGrid: true,
                    showLabel: true,
                    labelOffset: {
                        x: 0,
                        y: 5
                    },
                    labelInterpolationFnc: function (text) {
                        if (parseFloat(text) && parseFloat(text) !== 0) {
                            return abbreviateNumber(text);
                        }
                        return text;
                    }
                },
                seriesBarDistance: 80,
                plugins: [
                    Chartist.plugins.ctBarLabels({
                        labelInterpolationFnc: function (text) {
                            if (self.unitType == 'currency') {
                                var value = parseFloat(text) || 0;
                                if (self.unitScale == 'M') {
                                    var value = parseFloat(text) * 1000 / 1000000
                                }
                                return '$' + value.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 4});
                            }
                            return text.toLocaleString();
                        },
                        position: {
                            x: function (data) {
                                if (document.body.clientWidth < 768 && self.isSeriesChart) {
                                    return data.x2 + 30;
                                }
                                return ((data.x1 + data.x2) / 2);
                            },
                            y: function (data) {
                                if (document.body.clientWidth < 768 && self.isSeriesChart) {
                                    return ((data.y1 + data.y2) / 2);
                                }
                                return data.y2 - 10;
                            }
                        }
                    }),
                    Chartist.plugins.tooltip({
                        appendToBody: true,
                        transformTooltipTextFnc: function (value) {
                            // Define previous value function 
                            // This will give us the previous value in a defined array
                            function previousValue (num, arr) { 
                                if (num && arr) {
                                    return arr[(jq.inArray(num, arr) - 1 + arr.length) % arr.length];
                                }
                            }
                            
                            if (self.hideToolTip !== 'true') {
                                // Ensure value is an int
                                var valueNum = parseInt(value);
                                
                                // Iterate over our array of strings with map() and change it to numbers
                                var valueArray = self.data.series.map(Number);
                                
                                // Grab the position of the value in the array
                                var valueIndex = valueArray.indexOf(valueNum);
                                
                                // If the value is not the first position in our valueArray
                                if (valueIndex !== 0) {
                                    // Define previous and current years
                                    var previousYear = previousValue(valueNum, valueArray);
                                    var currentYear = valueNum;
                                    
                                    // Define year over year logic
                                    var yoyValue = ((currentYear - previousYear) / previousYear) * 100;
                                
                                    return yoyValue.toFixed(1) + '% y/y';
                                }
                            } else {
                                return;
                            }
                        }
                    }),
                ]
            }
            if (self.legend) {
                opts.plugins.push(Chartist.plugins.legend({
                    clickable: false,
                    position: jq(self.el).parent().find('.ct-legend-wrapper')[0] ? jq(self.el).parent().find('.ct-legend-wrapper')[0] : 'bottom'
                }));
            }
            if (self.isSeriesChart) {
                opts.plugins.push(Chartist.plugins.ctBarLabels({
                    useCustomData: true,
                    labelClass: 'ct-series-label',
                    position: {
                        x: function (data) {
                            if (document.body.clientWidth < 768) {
                                return data.x2 + 30;
                            }
                            return ((data.x1 + data.x2) / 2);
                        },
                        y: function (data) {
                            if (document.body.clientWidth < 768) {
                                return ((data.y1 + data.y2) / 2) + 10;
                            }
                            return data.y1 + 20;
                        }
                    },
                    labelInterpolationFnc: function (data) {
                        return self.data.seriesLabels[data.seriesIndex];   
                    }
                }));
            }
        }
        return opts;
    }
    
    
    function registerHandlers ()
    {
        self.chart.on('draw', function (event) {
            // X-axis label centering fix for IE11
            if (event.type === 'label' && event.axis && event.axis.units.pos === 'x') {
                if (!self.chart.supportsForeignObject) {
                    //console.log(event);
                    event.element.attr({
                        x: event.x + (event.width / 2) - 15,
                        'text-anchor': 'middle'
                    });
                }
            }
        });
        jq('.nav a').on('shown.bs.tab', function (e) {
            var target = jq(this).attr('href');
            if (jq(target).find(self.el).length > 0) {
                self.chart.update();
            }
        });
    }
    
    /**
     * Returns responsive options for any chart styles that require them
     **/
    function getResponsiveOptions () {
       var responsiveOpts = [];
       if (self.isSeriesChart) {
           var seriesOptsMobile = {
               horizontalBars: true,
               seriesBarDistance: 30,
               chartPadding: {
                   right: 25,
                   left: 45
               },
               axisX: {
                   showLabel: false,
                   offset: 0
               }
           }
           responsiveOpts.push(["screen and (max-width: 768px)", seriesOptsMobile]);
           
           var seriesOptsDesktop = {
               chartPadding: {
                   bottom: 25
               },
               axisX: {
                   labelOffset: {
                       x: 0,
                       y: 30
                   }
               }
            }
       }
       responsiveOpts.push(["screen and (min-width: 768px)", seriesOptsDesktop]);
       return responsiveOpts;
    }
    
    /**
     * Uses data attributes on a chart element and fetches data and labels for a specific chart.
     * Sets local properties after fetching the data successfully.
     * @return Promise
     **/
    function getChartData () {
        return new Promise(function (resolve, reject) {
            var url = new URL(window.location.protocol + '//' + window.location.hostname + apiUrl),
            params = {
                cid: self.cid,
                pid: self.pid,
                chart_name: self.name,
                field_name: self.fieldName,
                is_financial_chart: self.isFinancialChart,
                yoy_chart: self.isYoYChart,
                chart_title: self.title,
                tooltip_hidden: self.hideToolTip
            };
            Object.keys(params).forEach(function (key) {
                url.searchParams.append(key, params[key]);
            });
            fetch(url).then(function (response) {
                return response.json();
            }).then(function (results) {
                var resultsData = results.data.map(function (el, i) {
                        if (Array.isArray(el)) {
                            self.isSeriesChart = true;
                            self.data.seriesLabels = results.seriesLabels;
                            // If it's a series chart, we need to apply the match to each series.
                            return el.map(function (sEl, j) {
                                return sEl.match(/[\d.]+/g)[0];
                            });
                        } else {
                            return el.match(/[\d.]+/g)[0];
                        }
                    });
                    self.data.series = resultsData;
                    self.data.labels = results.labels;
                    // Holds full value strings to use in the legend
                    self.data.labelValues = results.data;
                    if (self.legend) {
                        //If there's a legend, transform the labels.
                        self.data.labels = results.labels.map(function (el, i) {
                                var prefix = '';
                                if (self.unitType == 'percentage') {
                                    prefix = '<span class="percent">' + getPercentValue(self.data.series[i], self.data.series) + '%</span>';
                                } else if (self.unitType == 'currency') {
                                    prefix = '<span class="currency">$' + self.data.labelValues[i] + '</span> ';
                                    if (self.unitScale == 'M') {
                                        el = el / 1000000
                                        el = el.toFixed(2);
                                    }
                                }
                                return prefix  + el;
                        });
                    }
                    //console.log(self.data);
                resolve();
            });
        });
    }
    
    /**
     * Gets percent values for charts that are using whole numbers in the data
     * but need to output those numbers as a percent total.
     * @return Number
     **/
    function getPercentValue(value, allValues) {
        var total = allValues.reduce(function (accumulator, currentValue) {
            return parseInt(accumulator) + parseInt(currentValue);
        });
        return Math.round((value / total) * 100);
    }
    
    function abbreviateNumber(value) {
      var newValue = value;
      var suffixes = ["", "K", "M", "B","T"];
      var suffixNum = 0;
      while (newValue >= 1000) {
        newValue /= 1000;
        suffixNum++;
      }
      if (Math.trunc(newValue) !== 0) {
          newValue = newValue.toPrecision(3);
      } else {
          newValue = Math.round(newValue);
      }
    
      newValue += suffixes[suffixNum];
      return newValue;
    }
    
    getChartData().then(function () {
      // We allow for entirely custom options to be passed via a JSON script.
      var customOpts = {};  
      if (document.getElementById(self.extraOptionsId)) {
          customOpts = JSON.parse(document.getElementById(self.extraOptionsId).innerHTML);
      }
      var opts = Object.assign({}, getOptions(), customOpts);
      if (self.type == 'pie') {
          self.chart = new Chartist.Pie(self.el, self.data, opts);
      }else {
          self.chart = new Chartist.Bar(self.el, self.data, opts, getResponsiveOptions());
      }
      registerHandlers();
    });
}

var charts = document.querySelectorAll('.chartist-chart')
if (charts.length) {
    charts.forEach(function (el) {
        new ChartBuilder(el);
    });
}